import React, {useState} from 'react';
import Button from "@mui/material/Button";
import {Share} from "@mui/icons-material";
import DialogPopUp from "../common/AlertDialog";
import {Flex} from "reflexbox";
import PropTypes from 'prop-types';
import secondsToHMSformat from "../helpers/secondsToHMSformat";
import CopyItem from "../common/CopyItem";

const ShareButton = (props) => {
  const [dialog, setDialog] = useState(false);

  const {friendlyCourseName, questionsCorrect, totalQuestions, time, totalScore} = props;

  const shareText = (`I challenge you to beat my score in Capital Clues \n 🧩🏛🗺🔎 
  \n Course: ${friendlyCourseName}
   ⭐️ Questions: ${questionsCorrect} of ${totalQuestions}
   ⏱ Time: ${secondsToHMSformat(time, 'plaintext')}
   🏆 Total Score: ${Math.floor(totalScore)} \n
   Download the Captial Clues app and play it for yourself`);


  const encodedShareText = encodeURIComponent(shareText);

  const shareUrl = "http://onelink.to/yfwjpb";

  const handleOnClick = () => {
    if (navigator.share) {
      navigator
        .share({
          //title: "Capital Clues",
          text: shareText,
          //url: shareUrl,
          //note if adding URL back, iOS sometimes drops the text if a url is included so you would just need to add the url to "text"
        })
        .catch(error => {
          console.error('Something went wrong sharing the blog', error);
        });
    } else {
      setDialog(true);
    }
  };

  const links = [
    {
      name: 'SMS',
      link: 'sms://?body=' + encodedShareText,
    },
    {
      name: 'Email',
      link: "mailto:?subject=Capital%20Clues%20Challenge&body=" + encodedShareText,
      // https://mailtolinkgenerator.com/
    },
  ];


  return (<>
    <Flex style={{width: '100%', justifyContent: 'center'}}>
      <Button variant={'contained'} color={'primary'} style={{width: 'fit-content'}}
              startIcon={<Share/>} onClick={handleOnClick}>
        Challenge friends</Button>
    </Flex>
    <DialogPopUp open={dialog}
                 body={(<Flex style={{flexDirection: 'column'}}>
                   {links.map((el) => (
                     <a href={el.link} target="_blank" rel="noreferrer" style={{textDecoration: 'none'}}>
                       <Button variant="contained" color="primary"
                               style={{margin: '4px 0', width: '100%'}}>{el.name}</Button>
                     </a>
                   ))}
                   <Flex style={{margin: '4px 0', width: '100%'}}>Copy Text: <CopyItem thingToCopy={shareText}/></Flex>
                 </Flex>)}
                 close={() => setDialog(false)}
                 title={'Share'}
                 hideContinue
    />
  </>)
};

ShareButton.propTypes = {
  friendlyCourseName: PropTypes.node.isRequired,
  questionsCorrect: PropTypes.node.isRequired,
  totalQuestions: PropTypes.node.isRequired,
  time: PropTypes.node.isRequired,
  totalScore: PropTypes.node.isRequired,
};

export default ShareButton;